import React from 'react';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';

import {agent} from '../../../services/api';
let apiAgent = new agent();

var token = localStorage.getItem(user_token);

export default class GetAgent extends React.Component {
  state = {
    consulta: []
  }

  componentDidMount() {
    //api.get(`/agent/${this.props.id}`, {headers: {'x-access-token': token}})
    apiAgent.getAgent(this.props.id)
      .then(res => {
        const consulta = res.data;
        this.setState({ consulta });
      })
  }

  render() {
    return (
      <ul>
        { this.state.consulta.map(details => 
        <>
          <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Representante da Instituição: </p><p>{details.name}</p>
          <p id="RI-Title-Cadastro-Paciente" >Telefone do(a) Representante da Instituição: </p><p>{details.phone}</p>
          <p id="RI-Title-Cadastro-Paciente" >E-mail do(a) Representante da Instituição: </p><p>{details.email}</p>
        </>)}
      </ul>
    )
  }
}